export class BreadcrumbMessages {
  public creer = 'breadcrumb.creer';
  public home = 'breadcrumb.home';
  public preferences = 'breadcrumb.preferences';
  public prefAddCpv ='breadcrumb.pref_add_cpv';
  public prefModifCpv ='breadcrumb.pref_modif_cpv';
  public prefAddDiffuseur ='breadcrumb.pref_add_diffuseur';
  public prefModifDiffuseur ='breadcrumb.pref_modif_diffuseur';
  public prefAddAcheteur ='breadcrumb.pref_add_acheteur';
  public prefModifAcheteur ='breadcrumb.pref_modif_acheteur';
  public topPage = 'breadcrumb.top_page';
  public bottomPage = 'breadcrumb.bottom_page';
  public title ='breadcrumb.listerPub';

  constructor() {
  }
}
